// extracted by mini-css-extract-plugin
module.exports = {"iframe":"styles_iframe__TnTzB","submitButton":"styles_submitButton__B7_19"};